const badges = [
  "advanced-tier-services-badge-glow",
  "ai-services-competency-badge-glow",
  "amazon-connect-delivery-badge-glow",
  "isv-accelerate-badge-glow",
];

const HeroSection = () => {
  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <section className="hero-section-blk">
      <video autoPlay muted loop playsInline>
        <source
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/videos/video-background.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div className="hero-section-overlay">
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/left-light-beams.png"
          alt="Left Light Beams"
          className="left-light-beam"
        />
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/right-light-beams.png"
          alt="Right Light Beam Pattern"
          className="right-light-beam "
        />
        <img
          src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hero-circle-pattern.png"
          alt="Hero Circle Pattern"
          className="center-light-beam"
        />
      </div>
      <div className="hero-section-content">
        <div>
          {badges.map((badge, index) => (
            <img
              key={index}
              src={`https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/images/${badge}.png`}
              alt={badge.replace(/-/g, " ")}
            />
          ))}
        </div>

        <h1 className="text-[78px] font-semibold">
          Welcome to iCXeed's AWS Partner Profile
        </h1>
        <p className="max-w-[850px] text-xl leading-[30px] text-[#CDCFD3]">
          <span className="font-bold">iCXeed</span> is the only AWS partner in
          the ANZ/APAC region combining Advanced Tier Services status, the AI
          Services Competency, and Amazon Connect Delivery specialisation with a
          proven track record of deploying agentic AI customer experiences.
        </p>
        <div className="flex items-center justify-center mt-[30px]">
          <button
            className="glow-button get-started-button mr-4"
            onClick={() => scrollToSection("ask-iris")}
          >
            <span>Ask iRis</span>
            <img
              className="background-image-button"
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hover-button.png"
              alt="Ask iRis Button"
            />
          </button>
          <a
            href="/files/iCXeed Partner Battlecard.pdf"
            download="iCXeed-Battlecard.pdf"
            className="glow-button get-started-button"
          >
            <span>Download iCXeed Battlecard</span>
            <img
              className="background-image-button"
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hover-button.png"
              alt="Hover Button"
            />
          </a>
        </div>
      </div>
      <div className="bottom-hero-pattern"></div>
    </section>
  );
};

export default HeroSection;
